import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private featureFlags: { [key: string]: boolean } =
    typeof environment.featureFlags === 'string'
      ? JSON.parse(environment.featureFlags)
      : environment.featureFlags;

  isFeatureEnabled(featureName: string): Observable<boolean> {
    return of(!!this.featureFlags[featureName]);
  }
}
